module.exports = __webpack_public_path__ + "img/sensor-on.02cbf123.png";